export default {
  // Note: Current item is *not* part of the queue
  currentItem: null,
  upcomingItems: [],
  playedItems: []
};
